  $('.slick-carousel').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [

              {
            breakpoint: 9999,
            settings: "unslick"
        },
      
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        }
      }
      // Add more responsive breakpoints if needed
    ],
    customPaging: function(slider, i) {
      // Customize the dot (pagination) with Font Awesome heart icon
      return '<div class="barracuda-dot visible"></div>';
    }
});



$(document).ready(function() {
    $('.set__remove').on('click', function(event) {
        event.preventDefault(); // Prevent the default action of the link

        // Get the value of the data-ids attribute
        var variantIds = $(this).data('ids');

        // Split the variant IDs into an array
        var variantIdArray = variantIds.split(',');

        // Construct the updates object
        var updates = {};
        variantIdArray.forEach(function(variantId) {
            updates[variantId.split(':')[0]] = 0; // Set quantity to 0 for each variant ID
        });

        // Send a POST request to update the cart
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                updates: updates
            },
            dataType: 'json',
            success: function(data) {
                // Cart updated successfully
                console.log('Cart updated successfully');
                // Optionally, reload the page to reflect the updated cart
                window.location.reload();
            },
            error: function(xhr, status, error) {
                // Error handling
                console.error('Error updating cart:', error);
            }
        });
    });
});




$(document).ready(function() {
    // Function to update the cart quantity
    function updateCartQuantities(variantIds, newQuantity) {
        // Construct the updates object
        var updates = {};
        variantIds.forEach(function(variantId) {
            updates[variantId] = newQuantity;
        });

        // Send a POST request to update the cart
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                updates: updates
            },
            dataType: 'json',
            success: function(data) {
                // Cart updated successfully
                console.log('Cart updated successfully');
                // Optionally, reload the page to reflect the updated cart
                window.location.reload();
            },
            error: function(xhr, status, error) {
                // Error handling
                console.error('Error updating cart:', error);
            }
        });
    }

    // Plus button click event handler
    $('.feather-plus-circle').on('click', function() {
        var $input = $(this).closest('.barracuda-count').find('input');
        var variantIdsString = $input.data('variant-ids');
        if (!variantIdsString) return; // Check if the attribute exists
        var variantIds = variantIdsString.split(',');
        var newQuantity = parseInt($input.val(), 10) + 1;
        updateCartQuantities(variantIds, newQuantity);
    });

    // Minus button click event handler
    $('.feather-minus-circle').on('click', function() {
        var $input = $(this).closest('.barracuda-count').find('input');
        var variantIdsString = $input.data('variant-ids');
        if (!variantIdsString) return; // Check if the attribute exists
        var variantIds = variantIdsString.split(',');
        var newQuantity = parseInt($input.val(), 10) - 1;
        if (newQuantity >= 0) {
            updateCartQuantities(variantIds, newQuantity);
        }
    });
});


